module.exports = __webpack_public_path__ + "img/homelogo.e44c987c.png";